
/* injects from baggage-loader */

import React, {Component} from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import Helpers from "../../../helpers/helperFunctions";
import PropTypes from "prop-types";
import { Link } from "react-router";

class RegionCompetition extends Component {
    render () {
        let {data, gameType, sportAlias, regionId} = this.props;
        return data ? (<li key={data.id + data.game} onClick={() => this.props.setRegionCompetitionIds(regionId, data.id)}>
            <Link to={`/${gameType}/${sportAlias}/${regionId}/${data.id}`} activeClassName={"active"}>
                <p><span>{data.name}</span> <i>({data.game})</i></p>
            </Link>
        </li>) : null;
    }
}

RegionCompetition.propTypes = {
    data: PropTypes.object,
    compId: PropTypes.number,
    selectorKey: PropTypes.string,
    regionId: PropTypes.number,
    sportAlias: PropTypes.string,
    gameType: PropTypes.string
};

const mapStateToProps = (state, ownParams) => {
    return createSelector(
        [
            state => JSON.stringify((() => {
                let region = state.swarmData.data[ownParams.selectorKey][0].region,
                    comp;
                Helpers.objectToArray(region).forEach((region) => {
                    if (region.competition[ownParams.compId]) {
                        comp = region.competition[ownParams.compId];
                    }
                });
                return comp;
            })())
        ],
        (data) => {
            return {
                data: data && JSON.parse(data)
            };
        });
};

export default connect(mapStateToProps)(RegionCompetition);